import type {
  OrganizationManagedMemberRole,
  OrganizationMemberDelivery,
  OrganizationMemberInput,
  OrganizationMemberRole,
} from '../types';

export const ORGANIZATION_MEMBER_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function getOrganizationMemberRoleOptions(
  allowOwner: boolean
): Array<{ value: OrganizationMemberRole; label: string }> {
  return [
    ...(allowOwner ? [{ value: 'owner' as const, label: 'Owner' }] : []),
    { value: 'admin' as const, label: 'Co-owner' },
    { value: 'member' as const, label: 'Member' },
  ];
}

export function formatOrganizationMemberRole(role: OrganizationMemberRole): string {
  return (
    getOrganizationMemberRoleOptions(true).find((option) => option.value === role)?.label ?? role
  );
}

export function formatOrganizationMemberDelivery(delivery: OrganizationMemberDelivery): string {
  return delivery === 'invite' ? 'Invite' : 'Direct';
}

export function normalizeOrganizationMemberForRole(
  member: OrganizationMemberInput,
  role: OrganizationMemberRole
): OrganizationMemberInput {
  if (role === 'owner') {
    return { ...member, role, delivery: 'direct' };
  }
  return { ...member, role };
}

export function normalizeOrganizationMemberInput(
  member: OrganizationMemberInput
): OrganizationMemberInput {
  const email = member.email.trim().toLowerCase();
  const next: OrganizationMemberInput = {
    ...member,
    email,
  };

  if (next.kind === 'email') {
    next.delivery = 'invite';
    if (next.role === 'owner') {
      next.role = 'member';
    }
  }

  if (next.delivery === 'direct') {
    next.kind = 'existing';
  }

  if (next.role === 'owner') {
    next.delivery = 'direct';
  }

  return next;
}

export function isManagedOrganizationMemberRole(
  role: OrganizationMemberRole
): role is OrganizationManagedMemberRole {
  return role !== 'owner';
}
